// src/modules/login/CreateUser.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // useParams for token
import Form from '../../components/shared/Form';
import Input from '../../components/shared/Input';
import Button from '../../components/shared/Button';
import { createUser } from '../auth/authService';

const CreateUser = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // useNavigate replaces useHistory

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createUser({ email, password });
      navigate('/login');
    } catch (err) {
      setError('Failed to create account');
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <h2>Create Account</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <Input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button type="submit">Create Account</Button>
    </Form>
  );
};

export default CreateUser;
